import { render, staticRenderFns } from "./class_course_info.vue?vue&type=template&id=37937abe&scoped=true"
import script from "./class_course_info.vue?vue&type=script&lang=ts"
export * from "./class_course_info.vue?vue&type=script&lang=ts"
import style0 from "./class_course_info.vue?vue&type=style&index=0&id=37937abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37937abe",
  null
  
)

export default component.exports